import { FrontTheme } from '@/components/Front/theme';
import { GenericSlot } from 'base/components/GenericSlot';

export const Front = GenericSlot({
  as: 'div',
  theme: FrontTheme,
});
